import React, { Component } from 'react';
import { inject } from 'mobx-react';
import WarningIcon from '@material-ui/icons/Warning';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import OstolaskuStatusIcon from '../Ostolaskut/OstolaskuStatusIcon';
import utils, { currency } from '../../utils';
import HyvitysChip from './HyvitysChip';

@inject('ostolaskuStore')
class OstolaskuRow extends Component {
    handleClick = () => {

        this.props.ostolaskuStore.showReceipt(this.props.data);
    }

    render() {
        const { data } = this.props;

        const isExpired = utils.ymdIsExpired(data.ERAPVM);
        const isExpiring = !isExpired && utils.ymdIsExpiring(data.ERAPVM);

        return (
            <ListItem
                button
                onClick={this.handleClick}
            >
                <OstolaskuStatusIcon data={data} />

                <ListItemText
                    // primary={data.TOIMITTAJANIMI}
                    primary={<div>
                        {data.TOIMITTAJANIMI}
                        {data.hyvitys &&
                            <HyvitysChip />}
                    </div>}
                    secondary={
                        <span className="row" style={{ alignItems: 'center', fontWeight: data.laskuvaihe !== 'VALMIS' && (isExpired || isExpiring) ? 600 : 400 }}>
                            {
                                data.laskuvaihe !== 'VALMIS' && isExpired &&
                                <WarningIcon style={{ width: 16, height: 16, marginRight: 6 }} />
                            }
                            {data.SUORITUSPVM ? utils.ymd2dmy(data.SUORITUSPVM) : utils.ymd2dmy(data.ERAPVM)}

                        </span>
                    }
                />

                <div className="text-right">
                    <div className="profitrow-id">#{data.ORLASKUNUMERO}</div>
                    <div>{currency(data.LASKUNSUMMA)}</div>
                </div>
            </ListItem>
        );
    }
}
export default OstolaskuRow;